import { container, singleton } from "tsyringe";
import MediaApi from "api/clapaction/projects/[id]/config/MediaApi";
import MediaRequestResource from "common/resources/Project/Config/Media/MediaRequestResource";
import MediaResponseResource from "common/resources/Project/Config/Media/MediaResponseResource";
import toValidationError from "utils/toValidationError";

@singleton()
export default class MediaService {
	private api: MediaApi = container.resolve(MediaApi);

	public async getByProjectId(projectId: string): Promise<MediaResponseResource[]> {
		return this.api.getByProjectId(projectId).catch(toValidationError);
	}

	public async getById(projectId: string, mediaId: string): Promise<MediaResponseResource> {
		return this.api.getById(projectId, mediaId).catch(toValidationError);
	}

	public async downloadFile(projectId: string, mediaId: string): Promise<Blob> {
		return this.api.downloadFile(projectId, mediaId).catch(toValidationError);
	}

	public async downloadPreviewImage(projectId: string, mediaId: string): Promise<Blob> {
		return this.api.downloadPreviewImage(projectId, mediaId).catch(toValidationError);
	}

	public async create(projectId: string, data: MediaRequestResource, file?: File): Promise<MediaResponseResource> {
		return this.api.create(projectId, data, file).catch(toValidationError);
	}

	public async update(projectId: string, mediaId: string, data: MediaRequestResource, file?: File): Promise<MediaResponseResource> {
		return this.api.update(projectId, mediaId, data, file).catch(toValidationError);
	}

	public async delete(projectId: string, mediaId: string): Promise<void> {
		return this.api.delete(projectId, mediaId).catch(toValidationError);
	}

	public async getIframe(projectId: string, mediaId: string): Promise<{ iframe: string | null }> {
		return this.api.getIframe(projectId, mediaId).catch(toValidationError);
	}
}
